<template>
  <div class="user-dashboard-container">
    <SideBar class="sidebar" />

    <div class="dashboard-content">
      <div class="maindash-content">
        <!-- <SearchBar @update:search="handleSearch" /> -->

        <div class="title-container">
          <div class="keep-going-title">Keep Going</div>
        </div>

        <!-- Bootstrap Carousel -->
        <div id="categoryCarousel" class="carousel slide">
          <div class="carousel-inner">
            <!-- 假设每4张卡片为一组进行轮播 -->
            <div
              class="carousel-item"
              v-for="(group, index) in cardGroups"
              :key="`group-${index}`"
              :class="{ active: index === 0 }"
            >
              <div class="d-flex justify-content-around">
                <CategoryCard
                  v-for="item in group"
                  :key="`${item.categoryId}-${item.latestTaskTitle}`"
                  :categoryName="item.name"
                  :categoryId="item.categoryId"
                  :latestTaskTitle="item.latestTaskTitle"
                  @edit-category="handleEditCategory"
                />
              </div>
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#categoryCarousel"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#categoryCarousel"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <!-- CategoryEditor 组件，使用 v-if 控制显示隐藏 -->
        <CategoryEditor
          v-if="showEditor"
          :categoryId="editingCategoryId"
          :categoryName="editingCategoryName"
          @cancel="handleCancelEdit"
          @confirm="handleConfirmEdit"
        />

        <div class="today-title-container">
          <div class="today-title">{{ formattedToday }}</div>
        </div>

        <BaseList
          :tasks="tasksForToday"
          @openNewTaskModal="handleOpenNewTaskModal"
          :search-query="searchQuery"
          @openTaskModal="handleOpenTaskModal"
        />
        <!-- BasicModal 的显示控制通过 v-if 或 v-show -->
        <BasicModal
          v-if="isModalVisible"
          :isDetailMode="isDetailMode"
          :task="selectedTask"
          @closeModal="isModalVisible = false"
          @newTaskCreated="handleNewTask"
          @updateTaskTiming="handleUpdateTaskTiming"
          @task-ended="handleTaskEnded"
          @update-task="handleUpdateTask"
          :categories="categoryCards"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/global/SideBar.vue";
// import SearchBar from "@/components/global/SearchBar.vue";
import CategoryCard from "@/components/dash/CategoryCard.vue";
import BaseList from "@/components/global/BaseList.vue";
import { ref, computed } from "vue";
import CategoryEditor from "@/components/category/CategoryEditor.vue";
import BasicModal from "@/components/global/BasicModal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SideBar,
    // SearchBar,
    CategoryCard,
    BaseList,
    CategoryEditor,
    BasicModal,
  },
  data() {
    return {
      showEditor: false,
      editingCategoryId: null,
      isModalVisible: false, // 控制模态框显示的状态
      isDetailMode: false, // 控制模态框是显示任务详情还是添加新任务的模式
      selectedTask: null, // 存储当前选中的任务
      latestTaskTitle: "", // 添加这一行
    };
  },
  setup() {
    const categoryCards = ref([
      { categoryId: "1", name: "Education" },
      { categoryId: "2", name: "Healthcare" },
      { categoryId: "3", name: "Financial" },
      { categoryId: "4", name: "Electronics" },
      { categoryId: "5", name: "Digital" },
      { categoryId: "6", name: "Goverment" },
      { categoryId: "7", name: "Manufacturing" },
      { categoryId: "8", name: "Energy" },
    ]);
    const responsiveOptions = ref([
      // ...responsive options here
    ]);
    console.log(categoryCards.value); // 打印以确认数据结构

    // 新增加的今天日期逻辑
    const today = new Date();
    const formattedToday = computed(() => {
      return today.toISOString().split("T")[0]; // 格式化为 YYYY-MM-DD
    });

    return { categoryCards, responsiveOptions, formattedToday };
  },

  methods: {
    handleOpenNewTaskModal() {
      this.$router.push({ name: "PlanList", query: { newTask: true } });
    },
    handleEditCategory({ categoryId, categoryName }) {
      console.log("Editing category ID:", categoryId); // 确认方法被触发和ID值

      this.editingCategoryId = categoryId;
      this.editingCategoryName = categoryName; // 新增状态来存储当前编辑的类别名称

      this.showEditor = true;
    },
    handleCancelEdit() {
      this.showEditor = false;
    },
    handleConfirmEdit(updatedName) {
      // 查找要更新的类别在数组中的索引
      const index = this.categoryCards.findIndex(
        (card) => card.categoryId === this.editingCategoryId
      );
      if (index !== -1) {
        // 更新该类别的名称
        this.categoryCards[index].name = updatedName;
        // 隐藏编辑器
        this.showEditor = false;
        // 更新类别数据
        this.$store.commit("updateCategories", this.categoryCards);
      }
    },
    handleOpenTaskModal(task) {
      this.selectedTask = task; // 假设你有一个selectedTask来存储当前选中的任务
      this.isModalVisible = true; // 控制BasicModal的显示
      this.isDetailMode = true; // 添加时设置为详情模式
    },
    handleTaskEnded(task) {
      console.log("Received task-ended event:", task);

      // 更新对应类别的 CategoryCard 的 latestTaskTitle
      this.categoryCards.forEach((card) => {
        if (card.name === task.category) {
          card.latestTaskTitle = task.title;
        }
      });
      console.log("Updated categoryCards:", this.categoryCards);
    },
    handleUpdateTask(updatedTask) {
      const taskIndex = this.tasksForToday.findIndex(
        (task) => task.id === updatedTask.id
      );
      if (taskIndex !== -1) {
        Object.assign(this.tasksForToday[taskIndex], updatedTask);
      }
    },
  },
  computed: {
    ...mapGetters(["categories"]),
    ...mapGetters(["tasksForToday"]),

    cardGroups() {
      let groupSize = 4;
      return this.categoryCards.reduce((acc, item, index) => {
        const groupIndex = Math.floor(index / groupSize);
        if (!acc[groupIndex]) acc[groupIndex] = [];
        acc[groupIndex].push(item);
        return acc;
      }, []);
    },
  },
};
</script>

<style>
body {
  position: relative;
  min-height: 100vh !important;
}
.maindash-content {
  padding: 70px 100px;
}

.keep-going-title {
  font-size: 1.5rem;
  margin-right: 0px; /* 调整与按钮的右侧间距 */
}

.today-title-container {
  margin-bottom: 10px;
}

.today-title {
  font-size: 1.5rem;
  padding-top: 40px;
}

.carousel-control-prev {
  left: -5% !important; /* 將左邊按鈕向外推 */
}
.carousel-control-next {
  right: -5% !important; /* 將右邊按鈕向外推 */
}
@media (max-width: 768px) {
  .maindash-content {
    padding: 50px 0px; /* 减小内边距以适应较小的屏幕 */
    max-width: 100%; /* 设置最大宽度，根据需要调整 */
    margin: 0 auto !important; /* 水平居中 */
    overflow: none; /* 如果内容过长可以滚动 */
  }
  .keep-going-title,
  .today-title {
    font-size: 1.2rem; /* 减小字体大小 */
  }
}
</style>
